/**
 * @file 获取资源列表
 * @author liudy
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IDeleteHomeworkInput {
    homework_id: number;
}

export interface IDeleteHomeworkOutput {
    del_ret: number;
}

export const deleteHomework = fetchDataSync((data: IDeleteHomeworkInput): Promise<IResponse<IDeleteHomeworkOutput>> => {
    return fetchData(Api.HOMEWORK_DELETE, data).then((res: IResponse<IDeleteHomeworkOutput>) => {
        return res;
    });
});

export const deleteHomeworkAsync = (data: IDeleteHomeworkInput): Promise<IResponse<IDeleteHomeworkOutput>> => {
    return fetchData(Api.HOMEWORK_DELETE, data).then((res: IResponse<IDeleteHomeworkOutput>) => {
        return res;
    });
};
